import React from "react";
import { fmtTime } from "../../lib/api";
import { Megaphone, Radio, Users, Lock } from "lucide-react";

function icon(t) {
  if (t === "private") return <Lock size={13} />;
  if (t === "group") return <Users size={13} />;
  if (t === "info_descending") return <Megaphone size={13} />;
  return <Radio size={13} />;
}

export default function Overview({ rows, onSelect }) {
  return (
    <div className="flex-1 overflow-y-auto p-5" style={{ background: "var(--r-void)" }}>
      <div className="max-w-3xl mx-auto">
        <div className="sys-label mb-1">SURVEILLANCE GLOBALE</div>
        <h2 className="font-title font-bold text-xl tracking-tight mb-5">TOUTES LES TRANSMISSIONS</h2>
        <div className="space-y-2">
          {rows.map((r) => (
            <button
              key={r.channel_id}
              data-testid={`overview-row-${r.channel_id}`}
              onClick={() => onSelect(r.channel_id)}
              className="w-full text-left frame p-3 flex items-center gap-3 hover:-translate-y-0.5 transition-transform"
              style={{ borderColor: r.player_unseen > 0 ? "var(--r-alert)" : undefined }}
            >
              <span className="text-[color:var(--r-primary)]">{icon(r.channel_type)}</span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="font-semibold text-sm truncate">{r.channel_name}</span>
                  {r.player_unseen > 0 && (
                    <span className="font-mono text-[10px] font-bold px-1.5 py-0.5 blink" style={{ background: "var(--r-alert)", color: "#fff" }}>
                      {r.player_unseen} JOUEUR
                    </span>
                  )}
                </div>
                <div className="sys-label truncate mt-0.5" style={{ textTransform: "none", letterSpacing: "normal" }}>
                  {r.last_message ? `${r.last_message.sender_name}: ${r.last_message.content}` : "—"}
                </div>
              </div>
              <span className="ts text-[color:var(--r-text-muted)]">{r.last_message ? fmtTime(r.last_message.created_at) : ""}</span>
            </button>
          ))}
          {rows.length === 0 && <div className="sys-label">AUCUNE ACTIVITÉ</div>}
        </div>
      </div>
    </div>
  );
}
